module.exports = __WEBPACK_EXTERNAL_MODULE__mfe_mfe_printer_remoteEntry_mjs_25c1e125__;